import Component from "./Component.js"
import Utils from "./Utils.js"

export default class Duration extends Component {

  constructor(props, context) {
    super(props, context)
    this.state.duration = this.player.duration
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onmediachange(event) {
    this.setState({duration: Math.round(this.player.duration)})
  }

  ondurationchange(event) {
    this.setState({duration: Math.round(event.detail)})
  }

  render() {
    return <span className="amp-duration">{Utils.formatTimecode(this.state.duration, this.state.duration)}</span>
  }

}
